// utils/formatUtils.js

/**
 * Formats amount string by abbreviating common units of measure
 * @param {string} amount - The amount string (e.g. "3.5GRAMS" or "1MILLILITERS")
 * @returns {string} Formatted amount string or empty string if N/A
 */
 export const formatAmount = (amount) => {
    // Return empty string if amount is N/A or null/undefined
    if (!amount || amount === 'N/A') {
      return '';
    }
    
    // Check for common units and replace them with abbreviations
    return amount
      .replace(/MILLIGRAMS/gi, 'mg')
      .replace(/MILLIGRAM/gi, 'mg')
      .replace(/GRAMS/gi, 'g')
      .replace(/GRAM/gi, 'g')
      .replace(/MILLILITERS/gi, 'mL')
      .replace(/MILLILITER/gi, 'mL')
      .replace(/ML/gi, 'mL')
      .trim();
  };
  
  /**
   * Returns empty string if value is N/A, otherwise returns the value
   * @param {string} value - The value to check
   * @returns {string} Original value or empty string if N/A
   */
  export const hideIfNA = (value) => {
    return (!value || value === 'N/A') ? '' : value;
  };